import { extraLongStaleTime } from 'constants/api';
import Api from 'core/api';
import useFetch from 'hooks/useFetch';

/**
 * @param {Object<QueryParams>} filters -> Query params of the district settings request
 * @param {boolean} enabled -> whether query is enabled or disabled, default is true
 * @param {Object<QueryOptions>} options -> options of the react-query {onSuccess, onError, select etc}
 * @returns @useDistrictSettings Promise<DistrictSettings>
 */
const useDistrictSettings = ({ filters, enabled = true, options = {} } = {}) =>
  useFetch({
    apiFunc: Api.slSchools.getDistrictSettings,
    apiFuncName: 'slSchools.getDistrictSettings',
    filters,
    options: { enabled, staleTime: extraLongStaleTime, ...options },
  });

export default useDistrictSettings;
